<div class="container-fluid">
  <div class="row">
    <!-- Search Panel -->
    <div class="col-md-4">
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0">
            <i class="fas fa-search-plus mr-2"></i>Conflict Check
          </h5>
        </div>
        <div class="card-body">
          <form (ngSubmit)="search()">
            <div class="form-group">
              <label for="name">Name</label>
              <input type="text" class="form-control" id="name"
                     [(ngModel)]="searchCriteria.name" name="name"
                     placeholder="Contact name or company">
            </div>

            <div class="form-group">
              <label for="ssn">SSN</label>
              <input type="text" class="form-control" id="ssn"
                     [(ngModel)]="searchCriteria.ssn" name="ssn"
                     placeholder="Social Security Number">
            </div>

            <div class="form-group">
              <label for="ein">EIN</label>
              <input type="text" class="form-control" id="ein"
                     [(ngModel)]="searchCriteria.ein" name="ein"
                     placeholder="Employer Identification Number">
            </div>

            <div class="form-group">
              <label for="phone">Phone</label>
              <input type="text" class="form-control" id="phone"
                     [(ngModel)]="searchCriteria.phone" name="phone"
                     placeholder="Phone number">
            </div>

            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" class="form-control" id="email"
                     [(ngModel)]="searchCriteria.email" name="email"
                     placeholder="Email address">
            </div>

            <div class="form-check mb-3">
              <input type="checkbox" class="form-check-input" id="notify"
                     [(ngModel)]="searchCriteria.notify" name="notify">
              <label class="form-check-label" for="notify">
                Send notification on completion
              </label>
            </div>

            <div class="btn-group w-100">
              <button type="submit" class="btn btn-primary" [disabled]="searching">
                <i class="fas fa-search mr-1"></i>
                <span *ngIf="!searching">Search</span>
                <span *ngIf="searching">Searching...</span>
              </button>
              <button type="button" class="btn btn-secondary" (click)="clearSearch()">
                <i class="fas fa-times mr-1"></i>Clear
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Recent Checks -->
      <div class="card mt-3">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-history mr-2"></i>Recent Checks
          </h6>
        </div>
        <div class="card-body p-0">
          <div *ngIf="loadingRecent" class="text-center p-3">
            <i class="fas fa-spinner fa-spin"></i> Loading...
          </div>
          <div *ngIf="!loadingRecent && recentChecks.length === 0" class="text-muted p-3">
            No recent conflict checks
          </div>
          <ul class="list-group list-group-flush" *ngIf="!loadingRecent && recentChecks.length > 0">
            <li *ngFor="let check of recentChecks"
                class="list-group-item list-group-item-action"
                [class.list-group-item-warning]="check.has_conflicts"
                (click)="viewCheck(check)"
                style="cursor: pointer;">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <small class="text-muted">{{ check.created_at }}</small>
                  <br>
                  <span *ngIf="check.matter_number">Matter #{{ check.matter_number }}</span>
                  <span *ngIf="!check.matter_number">Manual Search</span>
                </div>
                <span class="badge"
                      [class.badge-danger]="check.has_conflicts"
                      [class.badge-success]="!check.has_conflicts">
                  {{ check.conflicts_found }}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Results Panel -->
    <div class="col-md-8">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            <i class="fas fa-exclamation-triangle mr-2"></i>Results
          </h5>
          <button *ngIf="currentCheck && currentCheck.conflicts_found > 0"
                  class="btn btn-sm btn-outline-primary"
                  (click)="sendNotification()">
            <i class="fas fa-bell mr-1"></i>Send Notification
          </button>
        </div>
        <div class="card-body">
          <!-- No search yet -->
          <div *ngIf="!searched && !searching" class="text-center text-muted py-5">
            <i class="fas fa-search fa-3x mb-3"></i>
            <p>Enter search criteria and click Search to check for conflicts</p>
          </div>

          <!-- Searching -->
          <div *ngIf="searching" class="text-center py-5">
            <i class="fas fa-spinner fa-spin fa-3x mb-3"></i>
            <p>Searching for conflicts...</p>
          </div>

          <!-- Results -->
          <div *ngIf="searched && currentCheck">
            <!-- Summary -->
            <div class="alert"
                 [class.alert-success]="!currentCheck.has_conflicts"
                 [class.alert-warning]="currentCheck.has_conflicts">
              <strong>
                <span *ngIf="currentCheck.has_conflicts">
                  <i class="fas fa-exclamation-triangle mr-1"></i>
                  {{ currentCheck.conflicts_found }} potential conflict(s) found
                </span>
                <span *ngIf="!currentCheck.has_conflicts">
                  <i class="fas fa-check-circle mr-1"></i>
                  No conflicts found
                </span>
              </strong>
              <br>
              <small>Checked by {{ currentCheck.user_name }} on {{ currentCheck.created_at }}</small>
            </div>

            <!-- Searched Contacts -->
            <div *ngIf="currentCheck.searched_contacts && currentCheck.searched_contacts.length > 0" class="mb-3">
              <h6>Searched Contacts:</h6>
              <div class="d-flex flex-wrap">
                <span *ngFor="let contact of currentCheck.searched_contacts"
                      class="badge badge-secondary mr-2 mb-1">
                  {{ contact.name || contact.display_name }}
                  <small *ngIf="contact.matched_on">({{ contact.matched_on.join(', ') }})</small>
                </span>
              </div>
            </div>

            <!-- Conflict Details Table -->
            <div *ngIf="currentCheck.conflicts && currentCheck.conflicts.length > 0">
              <h6>Conflict Details:</h6>
              <div class="table-responsive">
                <table class="table table-sm table-hover">
                  <thead class="thead-light">
                    <tr>
                      <th>Contact</th>
                      <th>Matter</th>
                      <th>Role(s)</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let conflict of currentCheck.conflicts"
                        [class.table-warning]="conflict.archived">
                      <td>
                        <a href="javascript:void(0)" (click)="goToContact(conflict.contact_id)">
                          {{ conflict.contact_name }}
                        </a>
                      </td>
                      <td>
                        <a href="javascript:void(0)" (click)="goToMatter(conflict.matter_id)">
                          #{{ conflict.matter_number }}
                        </a>
                        <br>
                        <small class="text-muted">{{ conflict.matter_name }}</small>
                      </td>
                      <td>
                        <span *ngFor="let role of conflict.roles"
                              class="badge mr-1"
                              [ngClass]="getRolesBadgeClass([role])">
                          {{ role }}
                        </span>
                      </td>
                      <td>
                        <span class="badge"
                              [class.badge-secondary]="conflict.archived"
                              [class.badge-primary]="!conflict.archived">
                          {{ conflict.archived ? 'Archived' : conflict.matter_status }}
                        </span>
                      </td>
                      <td>
                        <button class="btn btn-sm btn-outline-primary"
                                (click)="goToMatter(conflict.matter_id)"
                                title="View Matter">
                          <i class="fas fa-external-link-alt"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
